var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNum3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3004 14.11C9.11035 14.11 8.24035 13.61 7.85035 12.94L8.60035 12.41C8.95035 12.96 9.48035 13.26 10.2904 13.26C11.3504 13.26 11.9604 12.74 11.9604 11.96C11.9604 11.19 11.3204 10.66 10.3104 10.66H9.60035V9.82H10.3104C11.2204 9.82 11.8104 9.32 11.8104 8.61C11.8104 7.89 11.2504 7.4 10.2904 7.4C9.54035 7.4 9.05035 7.69 8.75035 8.18L8.02035 7.66C8.40035 7.04 9.21035 6.55 10.3204 6.55C11.8404 6.55 12.8004 7.39 12.8004 8.55C12.8004 9.33 12.3604 9.9 11.6204 10.18V10.2C12.4904 10.51 12.9504 11.14 12.9504 11.99C12.9504 13.22 11.9404 14.11 10.3004 14.11Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum3);
export default __webpack_public_path__ + "static/media/num3.ef576571e08410badbd30a04f7fb05a4.svg";
export { ForwardRef as ReactComponent };